import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { browseItemsReducer, browseItemsActionReducer } from './browse-items/reducers';
import { categoriesReducer, userCategoriesReducer } from './categories/reducers';
import { itemReducer, itemLikeReducer } from './items/reducers';
import { projectReducer } from './project/reducers';
import { userReducer } from './users/reducers';
import { manufacturersReducer } from './manufacturers/reducers';
import { wishlistItemsReducer, wishlistItemsActionReducer } from './wishlist-items/reducers';
import { projectItemsReducer, projectItemsActionReducer } from './project-items/reducers';
import { configReducer } from './shared/reducers';
import { suggestedItemsReducer } from './suggested-items/reducers';
import { setReducer } from './set/reducers';
import { setsReducer } from './sets/reducers';
import { tagsReducer } from './tags/reducers';
import { storagesReducer } from './storages/reducers';
import { historyReducer } from './history/reducers';
import { projectsReducer } from './projects/reducers';
import { barcodeItemsReducer, barcodeItemsActionReducer } from './barcode-items/reducers';
import { barcodeCategoriesReducer } from './barcode-categories/reducers';
import { barcodeManufacturersReducer } from './barcode-manufacturers/reducers';
import { imageReducer, imageByUrlReducer } from './images/reducers';
import { itemsCategoriesReducer } from './items-categories/reducers';
import { versionReducer } from './version/reducers';

const createRootReducer = (history) => combineReducers({
  router: connectRouter(history),
  // app shared config storage (view mode, notifications, app overlay etc.)
  config: configReducer,
  user: userReducer,
  // SETS/ITEMS entities storage ('Browse' page)
  // all props which aren't required for grid/list/table view are omitted
  browseItems: browseItemsReducer,
  // ITEMS shortened entities storage ('Wishlist' page)
  // todo - consider replace with browseItemsReducer
  // when /items will have filter by "is_wishlisted" prop/query parameter supported
  // all props which aren't required for grid/list/table view are omitted
  wishlistItems: wishlistItemsReducer,
  // PROJECTS shortened entities storage ('Projects' page)
  // all props which aren't required for grid/list/table view are omitted
  projectItems: projectItemsReducer,
  browseItemsActions: browseItemsActionReducer, // SETS/ITEMS state storage select, open, etc ('Browse' page)
  wishlistItemsActions: wishlistItemsActionReducer, // ITEMS state storage select, open, etc ('Wishlist' page)
  projectItemsActions: projectItemsActionReducer, // PROJECTS state storage (select, open, etc) ('Projects' page)
  userCategories: userCategoriesReducer, // categories list extended with 'active' indicator
  item: itemReducer, // ITEM entity data (extended) and state ('Edit item' sidebar)
  project: projectReducer, // PROJECT entity data (extended)  and state ('Project details' page)
  set: setReducer, // SET entity data (extended) and state ('Set details' page)
  manufacturers: manufacturersReducer,
  // contain merged ITEM/TAG/CATEGORY short data list
  suggestedItems: suggestedItemsReducer,
  tags: tagsReducer,
  categories: categoriesReducer, // todo - check if can be completely replaced with userCategories
  storages: storagesReducer,
  // image upload data and load state
  image: imageReducer,
  imageByUrl: imageByUrlReducer,
  // todo - move into item reducer if no need to keep initial like state
  itemLikes: itemLikeReducer,
  // storage for SET short data
  // [{ name, id }] (usage: e.g. "Add item to set(s)" modal)
  sets: setsReducer,
  // storage for PROJECT short data
  // [{ name, id }] (usage: e.g. "Add item to set(s)" modal)
  projects: projectsReducer,
  // INTERNAL purpose only, see /history route
  history: historyReducer,
  barcodeItems: barcodeItemsReducer,
  barcodeCategories: barcodeCategoriesReducer,
  barcodeManufacturers: barcodeManufacturersReducer,
  barcodeItemsActions: barcodeItemsActionReducer,
  itemsCategories: itemsCategoriesReducer,
  version: versionReducer,
});

export default createRootReducer;
